import filters from './filters'
import { List, ListItem, Stack, Typography } from '@mui/material'
import { ScheduleContext } from '../../context'
import { useContextSelector } from 'use-context-selector'
import ScheduleFilterSelect from '@pages/private/Schedule/components/SideFilter/ScheduleFilterSelect/ScheduleFilterSelect'
import { SCHEDULE_FILTER } from './types'
import { SCHEDULE_TABS } from '@containers/EventsCalendar/types'

function EventsFilter() {
  const handleUpdateFilters = useContextSelector(
    ScheduleContext,
    (s) => s.handleUpdateFilters
  )

  const [tab, activeFilter, setActiveFilter] = useContextSelector(
    ScheduleContext,
    (s) => [s.tab, s.activeFilter, s.setActiveFilter]
  )

  const localFilters = filters.filter((f) => {
    if (tab === SCHEDULE_TABS.E_AGENDA) {
      return f.key === SCHEDULE_FILTER.EAGENDA
    }
    return true
  })

  return (
    <Stack>
      <Typography
        sx={{
          display:
            activeFilter === SCHEDULE_FILTER.UNDEFINED ? 'inherit' : 'none',
          fontSize: '14px',
          color: '$color-text-primary',
          marginBottom: '4px',
        }}
        data-testid="title"
        variant="$font-body-5"
      >
        Buscar agenda por:
      </Typography>

      <List disablePadding sx={{ marginTop: '0 !important' }}>
        {localFilters?.map((filter) => (
          <ListItem key={filter.attr + filter.label} disablePadding>
            <ScheduleFilterSelect
              filter={filter}
              handleUpdateSearch={handleUpdateFilters}
              activeFilter={activeFilter}
              setActiveFilter={setActiveFilter}
            />
          </ListItem>
        ))}
      </List>
    </Stack>
  )
}

export default EventsFilter
